import React from 'react';
import classNames from 'classnames';

import classes from './styles.module.scss';
import FilledButton from '../../Buttons/FilledButton';

export default function VideoApproval({
  openConfirmReviewModal,
  variant = 'banner',
}) {
  return (
    <div
      className={classNames(classes.VideoApproval, {
        [classes.inline]: variant === 'inline',
      })}
    >
      <div className={classes.buttons}>
        <FilledButton onClick={() => openConfirmReviewModal('approve')}>
          Approve
        </FilledButton>

        <FilledButton onClick={() => openConfirmReviewModal('deny')}>
          Deny
        </FilledButton>
      </div>
    </div>
  );
}
